import { useEffect, useRef, useState } from "react"
import { DateFormat, Icon, Text } from "components/common"
import DataTable from "components/common/dataTable/dataTable"
import { ActionButtons, TitleDescription } from "components/custom"
import { useGetEditLogsQuery } from "features/clients/detail/api"
import UserProfileSummary from "features/shared/components/userProfileSummary"
import { t } from "i18next"
import EditHistoryDetail from "./editHistoryDetail"
import { joinBytItems } from "utils"
import TimeFormat from "components/common/timeFormat/timeFormat"
import CollapsibleText from "components/common/collapsibleText"
import theme from "utils/themeVars"

const columns = () => [
  {
    title: t("Date/Time"),
    dataIndex: "date",
    key: "date",
    className: "tableStartSpace",
  },
  {
    title: t("By"),
    dataIndex: "editedBy",
    key: "editedBy",
  },
  {
    title: t("Logs"),
    dataIndex: "logs",
    key: "logs",
  },
  {
    title: t("Comment"),
    dataIndex: "comment",
    key: "comment",
  },
  {
    title: t("Detail"),
    dataIndex: "action",
    key: "action",
  },
]

const EditHistory = ({ client, getCount = () => {} }) => {
  const [index, setIndex] = useState()
  const editHistoryDetailRef = useRef()
  const [filter, setFilter] = useState({ pageLimit: 10, page: 0 })
  const { data, isFetching, isError, error, isLoading, refetch } = useGetEditLogsQuery({ clientId: client.id, filter })
  useEffect(() => {
    data?.count && getCount(data?.count)
  }, [data?.count])

  const onChangePage = (page, pageSize) => {
    setFilter(prev => ({ ...prev, pageLimit: pageSize, page: page }))
  }

  const getActionButtons = (index) => {
    return [
      {
        key: "detail",
        icon: "FiArrowUpRight",
        color: theme["primary-color"],
        size: "1.4em",
        content: t("Detail"),
        onClick: () => {
          setIndex(index)
          editHistoryDetailRef.current?.setVisible(true)
        },
      },
    ]
  }

  const getEditHistoryData = data => {
    let object =
      data?.length &&
      data.map((element, index) => {
        return {
          key: element?.key,
          date: (
            <TitleDescription
              title={<DateFormat date={element?.date} dateClassName="" />}
              gapSpace={4}
              description={<TimeFormat date={element?.date} isTimeOnlyStr />}
            />
          ),
          editedBy: !!element?.LoggedBy ? (
            <TitleDescription
              title={
                <div>
                  {element?.editedBy?.name}&nbsp;
                  <UserProfileSummary staffId={element?.editedBy?.id} />
                </div>
              }
              gapSpace={6}
              description={joinBytItems(
                [element?.editedBy?.designation, element?.editedBy?.city],
                <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />
              )}
            />
          ) : (
            t("Rule Engine")
          ),
          logs: <Text>{element?.log}</Text>,
          comment: element?.comment ? <CollapsibleText text={element?.comment} collapsibleLength={50} /> : "-",
          action: element?.isClientModified ? (
            <ActionButtons
              list={getActionButtons(index)}
              animate={false}
              style={{ "--hover-displacement": "-24px" }}
            />
          ): "-",
        }
      })

    const dataSource = object

    return dataSource
  }

  return (
    <>
      <DataTable
        data={getEditHistoryData(data?.data)}
        columns={columns()}
        pagination={{ totalCount: data?.count, pageOptions: [10, 25, 50] }}
        paginationOnBottom={true}
        paginationOnTop={false}
        loading={isFetching}
        onChangePage={onChangePage}
        error={error}
        onErrorRetry={refetch}
        noUrlPush={true}
        pageSize={filter.pageLimit}
        stickyOffset={0}
      />
      <EditHistoryDetail formRef={editHistoryDetailRef} client={client} editIndex={index} data={data} />
    </>
  )
}

export default EditHistory
